import { render, staticRenderFns } from "./ChatroomList.vue?vue&type=template&id=32894ac0&"
import script from "./ChatroomList.vue?vue&type=script&lang=js&"
export * from "./ChatroomList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports